'use strict';

var cookie = require('cookie-cutter');
var urlJoin = require('url-join');
var q = require('q');
var sendGet = require('./send-action').get;
var xhrHelpers = require('xhrhelpers');

var storeCsrfAsCookie = function(csrf) {
  cookie.set('csrftoken', csrf);
  return csrf;
};

function Csrf(options) {
  this._baseUrl = options.baseUrl;
  this._csrfUrl = options.csrfUrl || 'pb/csrf-token/';
}

Csrf.prototype.baseUrl = function(baseUrl) {
  this._baseUrl = baseUrl;
  return this;
};

Csrf.prototype.get = function() {
  if (cookie.get('csrftoken')) {
    return q(cookie.get('csrftoken'));
  }

  var uri = urlJoin(this._baseUrl, this._csrfUrl);

  return sendGet(uri)
    .then(xhrHelpers.responseObject)
    .get('csrf_token')
    .then(storeCsrfAsCookie);
};

module.exports = Csrf;
